"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _getRef = _interopRequireDefault(require("./getRef"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createRef || function createRef() {
  function ref(instanceOrNode) {
    ref.current = (0, _getRef.default)(instanceOrNode) || null;
  }

  ref.current = null;

  if (process.env.NODE_ENV !== 'production') {
    Object.seal(ref);
  }

  return ref;
};

exports.default = _default;